<template>
  <div class="user-cascader">
    <el-cascader
      v-model="_value"
      :options="options"
      :props="{
        emitPath: false,
        label: 'name',
        value: 'mobile',
        children: 'children',
        multiple:true
      }"
      filterable
      size="medium"
      :show-all-levels="false"
    ></el-cascader>
  </div>
</template>

<script>
import { Arrays } from "@/utils/Arrays.js";
export default {
  name: "UserCascader",
  props: ["value"],
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      options: [],
    };
  },
  created() {
    this.$api.dynamicForm.componentUser().then(({ code, data }) => {
      this.options = new Arrays().map([data], (item) => {
        item.children && !item.children.length && delete item.children;
        item.mobile = item.mobile || Math.random() + ''
        return item;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.user-cascader {
}
</style>